import { CommonModule } from '@angular/common';
import { Component, OnDestroy, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { PosCatalogSearchService } from '../../../services/pos-catalog-search.service';

/** Icons (`search`, `x`) come from `MILINCO_CORE_TABLER_ICONS` in app.config — do not import the Tabler barrel here (header is eager). */
@Component({
  selector: 'app-pos-header-search',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, TablerIconsModule],
  templateUrl: './pos-header-search.component.html',
  styleUrl: './pos-header-search.component.scss',
})
export class PosHeaderSearchComponent implements OnDestroy {
  readonly search = inject(PosCatalogSearchService);

  ngOnDestroy(): void {
    this.search.clear();
  }
}
